import { render, staticRenderFns } from "./tcustbase-add-or-updateeloan.vue?vue&type=template&id=b534c0ee&scoped=true&"
import script from "./tcustbase-add-or-updateeloan.vue?vue&type=script&lang=js&"
export * from "./tcustbase-add-or-updateeloan.vue?vue&type=script&lang=js&"
import style0 from "./tcustbase-add-or-updateeloan.vue?vue&type=style&index=0&id=b534c0ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b534c0ee",
  null
  
)

export default component.exports